import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  viewBoxBalanceContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 50,
    marginBottom: 60,
    flexWrap: 'nowrap'
  },
  viewBoxContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    columnGap: 40,
    flexWrap: 'wrap'
  }
})
